import { ErrorAlert } from '@/components/common/ErrorAlert';
import { AlbumState } from '@/data/models/albumState';
import { StateHistory } from '@/data/models/stateHistory';
import renderTextWithLinks from '@/utils/renderTextWithLinks';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface RejectionBannerProps {
  albumState?: StateHistory;
}

const RejectionBanner = ({ albumState }: RejectionBannerProps) => {
  const { t } = useTranslation();

  if (albumState?.newState !== AlbumState.Rejected) {
    return null;
  }

  const title = albumState.notes
    ? t('product.rejectionBanner.headerWithNotes')
    : t('product.rejectionBanner.headerWithoutNotes');

  return (
    <ErrorAlert
      dismissable={false}
      titleText={title}
      contentText={renderTextWithLinks(albumState.notes)}
    />
  );
};

export default RejectionBanner;
